"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.oneOfEachEmail = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var validators_1 = require("utils/form/validators");
var oneOfEachEmail = function (_a) {
    var emails = _a.emails;
    var errors = {};
    var emailToTeamMap = {};
    Object.entries(emails).forEach(function (_a) {
        var _b = __read(_a, 2), teamId = _b[0], email = _b[1];
        var emailError = (0, validators_1.getEmailError)(email);
        if (emailError) {
            errors[teamId] = emailError;
            return;
        }
        var alreadyExistingTeam = emailToTeamMap[email];
        if (!alreadyExistingTeam) {
            emailToTeamMap[email] = teamId;
            return;
        }
        if (!errors[alreadyExistingTeam]) {
            errors[alreadyExistingTeam] = 'Repeated Email';
        }
        errors[teamId] = 'Repeated Email';
    });
    return (0, isEmpty_1.default)(errors) ? undefined : { emails: errors };
};
exports.oneOfEachEmail = oneOfEachEmail;
